import React from 'react';

const SchedulesPage = () => {
  return (
    <div>
      <h2>Schedules Page</h2>
      <p>To find program schedules first select for the program you are interested in.</p>
    </div>
  );
};

export default SchedulesPage; 
